export const isSwappableProduct = (item, order) => {
    const swappableProductKeys = ['swappable_bonus_product', 'swappable_promo_product'];
    return swappableProductKeys.includes(item?.status) && order[`${item.status}s`]?.length > 1;
}
